module.exports = __webpack_public_path__ + "img/fish.8e3ce119.png";